import styled from "styled-components";
import media from "styled-media-query";

import TestimonyCell from "../cell/TestimonyCell";
import { useState } from "react";
import { Button, ColorV2 } from "@adoptaunabuelo/react-components";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useSelector } from "react-redux";
import { State } from "../../redux";

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;
const ButtonRow = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	margin-bottom: 8px;
	${media.lessThan("medium")`
		display: none;
	`}
`;
const CellRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan("medium")`
		overflow: scroll;
		width: calc(100vw - 48px);
		margin: 0px -24px;
		padding: 0px 24px;
	`}
`;

const TestimonyList = (props: Props) => {
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const [index, setIndex] = useState(0);

	return (
		<Container style={props.style}>
			<ButtonRow>
				<Button
					style={{
						borderRadius: 100,
						height: 40,
						width: 40,
						border: `1px solid ${ColorV2.border.neutralSoft}`,
					}}
					design="image"
					icon={<ChevronLeft />}
					disabled={index <= 0}
					onClick={() => {
						if (index > 0) setIndex(index - 1);
					}}
				/>
				<Button
					style={{
						borderRadius: 100,
						height: 40,
						width: 40,
						border: `1px solid ${ColorV2.border.neutralSoft}`,
					}}
					design="image"
					icon={<ChevronRight />}
					disabled={index+1 * 2 >= props.options.length - 1}
					onClick={() => {
						if (index * 2 < props.options.length - 1)
							setIndex(index + 1);
					}}
				/>
			</ButtonRow>
			<CellRow>
				{props.options
					.slice(
						isMobile ? 0 : index * 2,
						isMobile ? props.options.length : index * 2 + 2
					)
					.map((item, index) => (
						<TestimonyCell
							key={"testimony-" + index}
							testimony={item}
						/>
					))}
			</CellRow>
		</Container>
	);
};
export default TestimonyList;
export interface Props {
	style?: React.CSSProperties;
	options: Array<any>;
}
